import { type ReactNode, useContext, useMemo } from 'react'

import { tokens } from '~/shared/styles/generated/tokens'

import { ThemeContext } from './context'
import { resolveThemeToken } from './resolve'
import type { Theme } from './types'

type ThemeProviderProps = {
  children: ReactNode
}

/**
 * Тема одна — тёмная, всегда (спека 01 §7). Провайдер не переключает темы,
 * а лишь кладёт токены из tokens.config.ts в контекст для JS-потребителей.
 */
export function ThemeProvider(props: ThemeProviderProps) {
  const { children } = props

  const theme = useMemo<Theme>(
    () => ({
      colors: tokens.colors,
      radii: tokens.radii,
      shadows: tokens.shadows,
      space: tokens.space,
      motion: tokens.motion,
      resolve: resolveThemeToken,
    }),
    [],
  )

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export function useTheme(): Theme {
  const theme = useContext(ThemeContext)
  if (!theme) {
    throw new Error('useTheme должен вызываться внутри <ThemeProvider>')
  }
  return theme
}
